export const EPlanCouponApprovalStatus = {
  Approved: 0,
  Pending: 1,
  Rejected: 2,
} as const

export type EPlanCouponApprovalStatus = (typeof EPlanCouponApprovalStatus)[keyof typeof EPlanCouponApprovalStatus]
